export default __webpack_public_path__ + "static/media/net-ads.46f89050.png";